export default __webpack_public_path__ + "static/media/swap-vert.68ea9ec4.svg";